import { X } from 'lucide-react';
import { formatCompactPrice } from '@/utils/format';
import { getEffectiveFilterDefs, isArrayDef, optionLabel } from '@/utils/filterDefinitions';

const has = (v) => v !== undefined && v !== null && v !== '';

function buildChips(def, filters) {
  const out = [];
  if (def.keys) {
    const [lo, hi] = def.keys;
    const a = filters[lo];
    const b = filters[hi];
    if (!has(a) && !has(b)) return out;
    const fmt = (v) => (def.thousands ? formatCompactPrice(Number(v)) : v);
    let txt;
    if (has(a) && has(b)) txt = `${fmt(a)} – ${fmt(b)}`;
    else if (has(a)) txt = `${fmt(a)}+`;
    else txt = `≤ ${fmt(b)}`;
    out.push({ key: def.keys, label: `${def.label}: ${txt}` });
    return out;
  }
  const key = def.key;
  const v = filters[key];
  if (isArrayDef(def)) {
    (Array.isArray(v) ? v : []).forEach((val) => out.push({ key, value: val, label: optionLabel(def, val) }));
    return out;
  }
  if (!has(v)) return out;
  if (def.type === 'select') out.push({ key, label: `${def.label}: ${optionLabel(def, v)}` });
  else out.push({ key, label: `${def.label}: ${v}` });
  return out;
}

// Renders active filters as removable chips. onRemove(key[, value]) clears a filter.
export const AppliedChips = ({ filters, onRemove, onClearAll }) => {
  const chips = [];
  // listingType is shown via the For Sale / For Rent toggle, not as a chip.
  getEffectiveFilterDefs()
    .filter((def) => def.key !== 'listingType')
    .forEach((def) => chips.push(...buildChips(def, filters)));

  if (!chips.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="applied-filter-chips">
      {chips.map((c) => (
        <button
          key={`${Array.isArray(c.key) ? c.key.join('-') : c.key}-${c.value || ''}`}
          type="button"
          onClick={() => onRemove(c.key, c.value)}
          className="inline-flex items-center gap-1.5 rounded-full border border-sky-200 bg-sky-50 px-3 py-1 text-sm text-slate-700 hover:bg-sky-100 transition-colors"
        >
          {c.label}
          <X size={13} className="text-slate-400" />
        </button>
      ))}
      <button type="button" onClick={onClearAll} className="rounded-full px-3 py-1 text-sm font-medium text-blue-600 hover:bg-blue-50" data-testid="filters-clear-all-button">
        Clear all
      </button>
    </div>
  );
};
